<template>
    <div class="diagram-choose-number">
        <input ref="input0" class="diagram-choose-number-input" @keyup="inputOnChange(0)" type="tel" maxlength="1" v-model="num1">
        <input ref="input1" class="diagram-choose-number-input" @keyup="inputOnChange(1)" type="tel" maxlength="1" v-model="num2">
        <input ref="input2" class="diagram-choose-number-input" @keyup="inputOnChange(2)" type="tel" maxlength="1" v-model="num3">
        <input ref="input3" v-if="numberLen >= 4" class="diagram-choose-number-input" @keyup="inputOnChange(3)" type="tel" maxlength="1" v-model="num4">
    </div>
</template>

<script>

export default {
    name: 'DiagramChooseNumber',
    props: {
        numberLen: {
            type: Number,
            default() { return 3 }
        },
        parentNode: {
            type: Object,
            default() { }
        }
    },
    computed: {
        curDiagramInputNumber() {
            return this.$store.state.diagram.curDiagramInputNumber;
        }
    },
    data() {
        return {
            curFocused: 0,
            num1: '', num2: '', num3: '', num4: '',
        }
    },
    mounted: function() {
        this.$bus.on('resetDiagramChooseNumber', this.resetChooseNumber);
        setTimeout(() => {
            // console.log('input=====0', this.$refs.input0)
            if(this.curDiagramInputNumber != '') {
                let arr = this.curDiagramInputNumber.split('');
                this.num1 = arr[0]; this.num2 = arr[1]; this.num3 = arr[2];
                this.num4 = arr[3] ? arr[3] : '';
            }else {
                this.$refs.input0.focus();
            }
        }, 20);
    },
    destroyed() {
        this.$bus.off('resetDiagramChooseNumber', this.resetChooseNumber);
    },
    methods: {
        inputOnChange(index) {
            switch(index) {
                case 0:
                    this.$refs.input1.focus();
                    break;
                case 1:
                    this.$refs.input2.focus();
                    break;
                case 2:
                    if(this.numberLen >= 4) {
                        this.$refs.input3.focus();
                    }
                    break;
                case 3:
                    break;
                default:
                    break;
            }
            if(this.numberLen == 3) {
                if(this.num1 !== '' && this.num2 !== '' && this.num3 !== '') {
                    this.$store.state.diagram.curDiagramInputNumber = [this.num1, this.num2, this.num3].join('');
                }else {
                    this.$store.state.diagram.curDiagramInputNumber = '';
                }
            }else if(this.numberLen == 4) {
                if(this.num1 !== '' && this.num2 !== '' && this.num3 !== '' && this.num4 != '') {
                    this.$store.state.diagram.curDiagramInputNumber = [this.num1, this.num2, this.num3, this.num4].join('');
                }else {
                    this.$store.state.diagram.curDiagramInputNumber = '';
                }
            }
            if(this.parentNode && this.parentNode.name == 'DiagramEdit') {
                this.$store.state.diagram.diagramTypeDataChanged = true;
            }
            // console.log('inputOnChange----', index, this.$store.state.diagram.curDiagramInputNumber)
        },
        resetChooseNumber() {
            this.num1 = ''; this.num2 = ''; this.num3 = ''; this.num4 = '';
        }
    }
}
</script>